import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { Component } from "react";
am4core.addLicense("ch-custom-attribution");

class HorizontalBar extends Component {
  state = {
    chart: null,
    dateAxis: null,
    data: null,
  };
  componentDidMount() {
    const chart = am4core.create("chartdiv" + this.props.id, am4charts.XYChart);
    chart.cursor = new am4charts.XYCursor(); //instantiate object of xy chart called chart
    chart.cursor.lineY.disabled = true; // added to remove y axis line on hover
    chart.cursor.lineX.disabled = true; // added to remove x axis line on hover
    this.createChart(chart); //create a chart from prev var
    this.setState(() => ({ chart })); // state save in local component
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  createChart = (chart) => {
    const suppress = !!this.props.suppressChartFilterInteractions;
    // Add data
    chart.data = this.props.data ? this.props.data : [];

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "key";
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.rotation = 315;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.fontSize = 8;
    categoryAxis.renderer.labels.template.maxWidth = 100;
    categoryAxis.cursorTooltipEnabled = false; // added to remove category axis tooltip
    categoryAxis.renderer.labels.template.truncate = true;
    categoryAxis.renderer.labels.template.wrap = true;
    categoryAxis.paddingBottom = -30;
    categoryAxis.renderer.labels.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    categoryAxis.renderer.labels.template.interactionsEnabled = !suppress;
    if (!suppress) {
      categoryAxis.renderer.labels.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target.dataItem.dataContext.key;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", item);
        },
        this
      );
    }

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.cursorTooltipEnabled = false;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.cursorTooltipEnabled = false; // added to remove value axis tooltip
    valueAxis.title.text = this.props.mainLabel ? this.props.mainLabel : "";
    valueAxis.numberFormatter = new am4core.NumberFormatter();
    valueAxis.numberFormatter.smallNumberThreshold = 0.0001;
    valueAxis.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
    valueAxis.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
    ];

    // Create series
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.sequencedInterpolation = true;
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "key";
    series.adapter.add("tooltipHTML", () => {
      if (!!this.props.mainLabel && this.props.mainLabel === "Weight (kg)") {
        return `<span className="d-flex align-items-center" style="font-size: 12px;">{key}:<br/>{value} kg,<br/>{marketShare}%${suppress ? "" : ":<hr/> Click to Apply Filter"}</span>`;
      } else if (this.props.mainLabel.includes("%")) {
        return `<span className="d-flex align-items-center" style="font-size: 12px;">{key}:<br/>{value}${this.props.mainLabel}:${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
      } else {
        return `<span className="d-flex align-items-center" style="font-size: 12px;">{key}:<br/>{value} ${this.props.mainLabel},<br/>{marketShare}%${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
      }
    });
    series.columns.template.strokeWidth = 0;
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#271c45");
    series.tooltip.background.strokeWidth = 0;
    series.columns.template.tooltipX = am4core.percent(100);
    series.columns.template.tooltipY = am4core.percent(0);
    series.tooltip.label.maxWidth = 250;
    series.tooltip.label.wrap = true;
    series.numberFormatter = new am4core.NumberFormatter();
    series.numberFormatter.smallNumberThreshold = 0.0001;
    series.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
    series.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
    ];

    series.tooltip.pointerOrientation = "vertical";
    series.columns.template.column.fillOpacity = 0.8;

    // on hover, make corner radiuses bigger
    let hoverState = series.columns.template.states.create("hover");
    hoverState.properties.fill = am4core.color("#6f08f1");
    hoverState.properties.fillOpacity = 0.8;

    series.columns.template.adapter.add("fill", function () {
      return am4core.color("#D0D5DD");
    });
    chart.cursor.behavior = "none";
    series.columns.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    series.columns.template.interactionsEnabled = !suppress;
    if (!suppress) {
      series.columns.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target.dataItem.component.tooltipDataItem.dataContext;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", item.filterKey ? item.filterKey : item.key);
        },
        this
      );
    }
    // Cursor
  };
  render() {
    return (
      <div className="lineChart w-100 h-100">
        <div id={"chartdiv" + this.props.id} style={{ width: "100%", minHeight: "280px" }} />
        {/* {this.state.chart ?
              <AmchartsReact
                chart={this.state.chart}
              />
              : null} */}
      </div>
    );
  }
}
export default HorizontalBar;
